module.exports = __webpack_public_path__ + "cdeee44d1c84e83977698148f13af7c1.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Light.ttf
// module id = 394
// module chunks = 0